import { useEffect, useState } from "react";

const PROTECTED = "img, video, canvas, picture, [data-protect]";

export const Watermark = ({ className = "" }) => (
  <div aria-hidden data-testid="photo-watermark"
    className={`pointer-events-none select-none font-mono text-[11px] tracking-[0.3em] text-white/45 mix-blend-difference ${className}`}>
    © MROUE CANVAS
  </div>
);

export const MediaShield = () => (
  <div aria-hidden data-protect data-testid="media-shield" className="absolute inset-0 z-[1]" draggable={false} />
);

export const ProtectMedia = () => {
  const [note, setNote] = useState(null);

  useEffect(() => {
    const isMedia = (e) => e.target instanceof Element && e.target.closest(PROTECTED);
    const onMenu = (e) => {
      if (!isMedia(e)) return;
      e.preventDefault();
      setNote({ x: e.clientX, y: e.clientY, id: Date.now() });
    };
    const onDrag = (e) => { if (isMedia(e)) e.preventDefault(); };
    document.addEventListener("contextmenu", onMenu);
    document.addEventListener("dragstart", onDrag);
    document.body.classList.add("protect-media");
    return () => {
      document.removeEventListener("contextmenu", onMenu);
      document.removeEventListener("dragstart", onDrag);
      document.body.classList.remove("protect-media");
    };
  }, []);

  useEffect(() => {
    if (!note) return undefined;
    const t = setTimeout(() => setNote(null), 2200);
    return () => clearTimeout(t);
  }, [note]);

  if (!note) return null;
  const left = Math.min(note.x, window.innerWidth - 300);
  const top = Math.min(note.y + 12, window.innerHeight - 60);
  return (
    <div key={note.id} role="status" data-testid="copyright-note" style={{ left: Math.max(8, left), top }}
      className="copyright-note fixed z-[200] border border-white/20 bg-black/90 px-4 py-3 font-mono text-[12px] tracking-[0.15em] text-white backdrop-blur-md">
      © MROUE CANVAS – All rights reserved
    </div>
  );
};
